// extracted by mini-css-extract-plugin
export default {"flex-column":"closePostButton_flex-column__zlH7M","flex-row":"closePostButton_flex-row__H1CNv","page-size":"closePostButton_page-size__gIa3n","close":"closePostButton_close__JS-XR"};